module.exports = __webpack_public_path__ + "static/Tarini-d09f6f1f065ff9d2a0f81f83a2d80f72.jpg";